import { defineMessages } from 'react-intl';

import { ButtonSchema } from '@fhnw/schemas/button';
import { DividerSchema } from '@fhnw/schemas/divider';

const messages = defineMessages({
  Title: {
    id: 'label_title',
    defaultMessage: 'Title',
  },
  Description: {
    id: 'label_description',
    defaultMessage: 'Description',
  },
  Compact: {
    id: 'label_block_compact',
    defaultMessage: 'Compact',
  },
  CompactHelp: {
    id: 'help_block_compact',
    defaultMessage:
      'Reduces the spacing between the block content and the block header and footer',
  },
  FollowUp: {
    id: 'label_block_followup',
    defaultMessage: 'Follow up',
  },
  FollowUpHelp: {
    id: 'help_block_followup',
    defaultMessage:
      'Removes the spacing above the block and uses a third level heading for the block title',
  },
  FullBleed: {
    id: 'label_block_fullbleed',
    defaultMessage: 'Fullbleed',
  },
  FullBleedHelp: {
    id: 'help_block_fullbleed',
    defaultMessage: 'Extends the block contents to the full width of the block',
  },
  FullWidth: {
    id: 'label_block_fullwidth',
    defaultMessage: 'Full width',
  },
  FullWidthHelp: {
    id: 'help_block_fullwidth',
    defaultMessage: 'Extends the block to the full width of the window',
  },
  Divider: {
    id: 'label_divider',
    defaultMessage: 'Divider',
  },
  Actions: {
    id: 'label_actions',
    defaultMessage: 'Actions',
  },
  Section: {
    id: 'label_section',
    defaultMessage: 'Section',
  },
  Background: {
    id: 'label_background',
    defaultMessage: 'Background',
  },
  Brand: {
    id: 'label_brand',
    defaultMessage: 'Brand',
  },
  Invert: {
    id: 'label_invert',
    defaultMessage: 'Invert',
  },
  Hide: {
    id: 'label_hide',
    defaultMessage: 'Hide',
  },
  NavTitle: {
    id: 'label_nav_title',
    defaultMessage: 'Anchor Navigation Title',
  },
});

export const extendSchema = (props, schema) => {
  if (!schema) {
    schema = {};
  }

  schema.properties = {
    ...(schema?.properties || {}),
    block_compact: {
      title: props.intl.formatMessage(messages.Compact),
      description: props.intl.formatMessage(messages.CompactHelp),
      widgetOptions: {
        frontendOptions: {
          widget: 'checkbox',
        },
      },
    },
    block_followup: {
      title: props.intl.formatMessage(messages.FollowUp),
      description: props.intl.formatMessage(messages.FollowUpHelp),
      widgetOptions: {
        frontendOptions: {
          widget: 'checkbox',
        },
      },
    },
    block_fullbleed: {
      title: props.intl.formatMessage(messages.FullBleed),
      description: props.intl.formatMessage(messages.FullBleedHelp),
      widgetOptions: {
        frontendOptions: {
          widget: 'checkbox',
        },
      },
    },
    block_fullwidth: {
      title: props.intl.formatMessage(messages.FullWidth),
      description: props.intl.formatMessage(messages.FullWidthHelp),
      widgetOptions: {
        frontendOptions: {
          widget: 'checkbox',
        },
      },
    },
    block_title: {
      title: props.intl.formatMessage(messages.Title),
      widgetOptions: {
        frontendOptions: {
          widget: 'text',
        },
      },
    },
    block_nav_title: {
      title: props.intl.formatMessage(messages.NavTitle),
      widgetOptions: {
        frontendOptions: {
          widget: 'text',
        },
      },
    },
    block_lead: {
      title: props.intl.formatMessage(messages.Description),
      widgetOptions: {
        frontendOptions: {
          widget: 'textarea',
        },
      },
    },
    block_background: {
      title: props.intl.formatMessage(messages.Background),
      widgetOptions: {
        frontendOptions: {
          widget: 'select',
          widgetProps: {
            choices: [
              ['brand', props.intl.formatMessage(messages.Brand)],
              ['invert', props.intl.formatMessage(messages.Invert)],
            ],
          },
        },
      },
    },
    block_divider: {
      title: props.intl.formatMessage(messages.Divider),
      widgetOptions: {
        frontendOptions: {
          widget: 'custom_object_widget',
          widgetProps: {
            schema: DividerSchema(props),
          },
        },
      },
    },
    block_actions: {
      title: props.intl.formatMessage(messages.Actions),
      widgetOptions: {
        frontendOptions: {
          widget: 'custom_object_list_widget',
          widgetProps: {
            schema: ButtonSchema(props),
          },
        },
      },
    },
    block_hide: {
      title: props.intl.formatMessage(messages.Hide),
      widgetOptions: {
        frontendOptions: {
          widget: 'checkbox',
        },
      },
    },
  };

  schema.fieldsets = [
    ...(schema?.fieldsets || []),
    {
      fields: [
        'block_title',
        'block_nav_title',
        'block_lead',
        'block_background',
        'block_compact',
        'block_followup',
        'block_fullbleed',
        'block_fullwidth',
        'block_hide',
        'block_divider',
        'block_actions',
      ],
      id: schema?.fieldsets && schema.fieldsets.length ? 'block' : 'default',
      title: props.intl.formatMessage(messages.Section),
    },
  ];

  if (!schema?.required) {
    schema.required = [];
  }

  return schema;
};

const blockWrapperSchemaEnhancer = (func) => {
  const extender = (props) => {
    return extendSchema(props, func ? func(props) : props.schema);
  };
  return extender;
};

export default blockWrapperSchemaEnhancer;
